import React, { useEffect, useState } from "react";
import { replace, useNavigate } from "react-router-dom";
import { useAuth } from "../../AuthContext";  // Import useAuth
import logo from "../assets/logo.png";
import "../../style/ConfirmUsername.css";

const API_BASE_URL = process.env.REACT_APP_API_SOURCE;

const ConfirmUsername = () => {
    const navigate = useNavigate();
    const { logout } = useAuth(); // Get logout function from context
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");

    useEffect(() => {

        logout();
        // Parse token from the hash portion of the URL
        const hash = window.location.hash; // e.g., "#/confirm-username?token=XYZ"
        let token = null;
        if (hash) {
            const trimmedHash = hash.substring(1); // Remove the leading "#"
            const parts = trimmedHash.split("?");
            if (parts.length > 1) {
                const queryString = parts[1]; // "token=XYZ"
                const urlParams = new URLSearchParams(queryString);
                token = urlParams.get("token");
            }
        }

        if (!token) {
            setError("Invalid or missing confirmation token.");
            return;
        }

        const confirmUsername = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/backend/api/Settings/confirm_username_change.php?token=${token}`);

                const text = await response.text();
                console.log("Raw confirm_username_change response:", text);

                const result = JSON.parse(text);

                if (result.status === "success") {
                    setMessage("Username updated successfully. Please log in again.");
                } else {
                    setError(result.message);
                }
            } catch (err) {
                console.log("Confirm Username Error:", err);
                setError("An error occurred. Please try again later.");
            }
        };

        confirmUsername();
    }, [logout, navigate]);

    return (
        <div className="confirm-username-container">
            <div className="confirm-username-box">
                <div className="logo-container">
                    <img src={logo} alt="LockedIn Logo" className="logo" />
                </div>
                {message && <p className="success-message">{message}</p>}
                {error && <p className="error-message">{error}</p>}
                {message && (
                    <button 
                        className="redirect-btn" 
                        onClick={() => navigate("/login", {replace: true})}
                    >
                        Go to Login
                    </button>
                )}
            </div>
        </div>
    );
};

export default ConfirmUsername;